import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClockList16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconClockList16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2 8a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m4.5-5.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11m.5 3a.5.5 0 1 0-1 0v3h2.25a.5.5 0 0 0 0-1H7zM14.5 4h-2.876a6.5 6.5 0 0 0-.97-1H14.5a.5.5 0 0 1 0 1m0 3h-1.576a6.5 6.5 0 0 0-.237-1H14.5a.5.5 0 0 1 0 1m-1.813 3q.157-.485.237-1H14.5a.5.5 0 0 1 0 1zm-1.063 2a6.5 6.5 0 0 1-.97 1H14.5a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClockList16);
